export const initialState = {
  contratos: {
    listagemContratos: [],
    informacoesGerais: {
      totalParcelasEmAtraso: 0,
      valorTotalEmAtraso: 0,
      valorTotalSaldoDevedor: 0,
    },
    loading: false,
    error: false,
  },
  assinaturaPendente: {
    pendente: false,
    valor: 0,
    link: '',
    loading: false,
    error: false,
  },
  limite: {
    requestDone: false,
    total: 0,
    limiteMinimo: 0,
    novoContratoBloqueado: false,
    saldoDevedor: 0,
    quantidadeMaximaParcelas: 0,
    taxa: 0,
    taxaMes: 0,
    taxaFundo: 0,
    msgErro: '',
    msgBloqueio: '',
    loading: false,
    error: false,
  },
  simulacao: {
    valor: 0,
    parcelas: 0,
  },
  solicitacao: {
    requestDone: false,
    matrizOpcoesParcelas: [],
    dataPrimeiraParcela: '',
    valorLiberado: 0,
    valorParcelas: 0,
    parcelaMinCalculada: 0,
    dataPrevistaCredito: '',
    loading: false,
    error: false,
  },
};
